"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getOrderLineStartEndDate = void 0;
const dayjs = require("dayjs");
const getLatestOrderLineVersion_1 = require("./getLatestOrderLineVersion");
const getOrderLineStartEndDate = (item, format = "DD/MM/YYYY") => {
    if (!item.versions)
        return null;
    const latest_version = (0, getLatestOrderLineVersion_1.getLatestOrderLineVersion)(item.versions);
    if (!latest_version)
        return null;
    return {
        start: dayjs(latest_version.start_date).format(format),
        end: dayjs(latest_version.end_date).format(format),
    };
};
exports.getOrderLineStartEndDate = getOrderLineStartEndDate;
